import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import { IFabricationContractState } from '../../../store/ducks/fabrication-contracts/types';
import { IFabricationProjectsState } from '../../../store/ducks/fabrication-projects/types';
import { updateFabricationStep } from '../../../store/ducks/fabrication-purchase-order/actions';
import {
  DEFAULT_EXTRA_ITEM,
  getDefaultFabricationProjectItem,
  DEFAULT_WIRE_ITEM,
  EFabricationOrderSteps,
  EProductType,
  IConstructionIdentificationState,
  IDetailingProjectState,
  IExtraItensState,
  IFabricationPurchaseOrderState
} from '../../../store/ducks/fabrication-purchase-order/types';
import { EPurchaseRoutes } from '../purchase.routes';
import Checkout from './Checkout';
import ConstructionIdentification from './ConstructionIdentification';
import DetailingProject from './DetailingProject';
import ExtraItens from './ExtraItens';
import FabricationOrderSucess from './FabricationOrderSucess';
import LastOrders from './LastOrders';
import ReviewOrders from './ReviewOrder';

export enum EFabricationRoutes {
  CONSTRUCTION_IDENTIFICATION = '/construction-identification',
  DETAILING_PROJECT = '/detailing-project',
  EXTRA_ITENS = '/extra-itens',
  CHECKOUT = '/checkout',
  SUCCESS = '/success',
  LAST_ORDERS = '/last-orders',
  FABRICATION_REVIEW_ORDER = '/fabrication-review-order'
}

interface IFabricationRoutesProps {
  fabricationPurchaseOrder: IFabricationPurchaseOrderState;
  fabricationProjectsState: IFabricationProjectsState;
  contractsState: IFabricationContractState;

  constructionIdentificationState: IConstructionIdentificationState;
  setConstructionIdentificationState(
    constructionIdentificationState: IConstructionIdentificationState
  ): void;

  detailingProjectState: IDetailingProjectState;
  setDetailingProjectState: React.Dispatch<
    React.SetStateAction<IDetailingProjectState>
  >;

  extraItensState: IExtraItensState;
  setExtraItensState(extraItensState: IExtraItensState): void;
}

const FabricationRoutes: React.FC<IFabricationRoutesProps> = ({
  fabricationPurchaseOrder,
  fabricationProjectsState,
  contractsState,
  constructionIdentificationState,
  setConstructionIdentificationState,
  detailingProjectState,
  setDetailingProjectState,
  extraItensState,
  setExtraItensState
}) => {
  const path = `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}`;
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const fabricationOrderStep = useSelector(
    (appState: ApplicationState) =>
      appState.fabricationPurchaseOrder.fabricationOrderStep
  );
  const goToFabricationRoute = (route: EFabricationRoutes, state?: object) => {
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${route || ''}`,
      state
    );
  };
  const getFabricationPurchaseRouteByStep = (): EFabricationRoutes => {
    switch (fabricationOrderStep) {
      case EFabricationOrderSteps.DETAILING_PROJECT:
        return EFabricationRoutes.DETAILING_PROJECT;
      case EFabricationOrderSteps.EXTRA_ITENS:
        return EFabricationRoutes.EXTRA_ITENS;
      case EFabricationOrderSteps.CHECKOUT:
        return EFabricationRoutes.CHECKOUT;

      case EFabricationOrderSteps.CONSTRUCTION_IDENTIFICATION:
      default:
        return EFabricationRoutes.CONSTRUCTION_IDENTIFICATION;
    }
  };

  // atualiza step ao entrar em cada etapa de compra
  const onInitFabricationRoute = (fabricationStep: EFabricationOrderSteps) => {
    if (fabricationStep !== fabricationOrderStep)
      dispatch(updateFabricationStep(fabricationStep));
  };

  // redireciona para tela de sucesso, ao finalizar o envio do pedido
  useEffect(() => {
    if (
      !!fabricationPurchaseOrder.createdOrderId &&
      !pathname.includes(EFabricationRoutes.SUCCESS)
    ) {
      history.push(
        `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.SUCCESS}`
      );
    }
  });

  return (
    <>
      <Route path={`${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}`} exact>
        <Redirect to={`${path}${getFabricationPurchaseRouteByStep()}`} />
      </Route>

      <Route
        path={`${path}${EFabricationRoutes.LAST_ORDERS}`}
        exact
        render={() => (
          <>
            <LastOrders
              onBuyAgain={(fabricationPurchaseState) => {
                setConstructionIdentificationState({
                  ...fabricationPurchaseState.constructionIdentification,
                  desiredDate: constructionIdentificationState.desiredDate
                });
                setDetailingProjectState(
                  fabricationPurchaseState.detailingProject
                );
                setExtraItensState(fabricationPurchaseState.extraItens);
              }}
            ></LastOrders>
          </>
        )}
      />

      <Route
        path={`${path}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`}
        render={() => (
          <ConstructionIdentification
            constructionIdentificationState={constructionIdentificationState}
            setConstructionIdentificationState={
              setConstructionIdentificationState
            }
            goToFabricationRoute={goToFabricationRoute}
            onInitFabricationRoute={onInitFabricationRoute}
            //Remover onBuyAgain após a remoção do toggle (Ver últimos pedidos)
            onBuyAgain={(fabricationPurchaseState) => {
              setConstructionIdentificationState({
                ...fabricationPurchaseState.constructionIdentification,
                desiredDate: constructionIdentificationState.desiredDate
              });
              setDetailingProjectState(
                fabricationPurchaseState.detailingProject
              );
              setExtraItensState(fabricationPurchaseState.extraItens);
            }}
            onChangeContractNumber={() => {
              setDetailingProjectState({
                ...detailingProjectState,
                itens: [getDefaultFabricationProjectItem()],
                vehiclesTypes: undefined,
                productType: EProductType.CORTE_E_DOBRA,
                observation: ''
              });
              setExtraItensState({
                ...extraItensState,
                otherPieces: [DEFAULT_EXTRA_ITEM],
                annealedWires: [DEFAULT_WIRE_ITEM]
              });
            }}
          />
        )}
      />

      <Route
        path={`${path}${EFabricationRoutes.DETAILING_PROJECT}`}
        render={() => (
          <>
            {constructionIdentificationState.contractNumber &&
              constructionIdentificationState.location && (
                <DetailingProject
                  constructionIdentificationState={
                    constructionIdentificationState
                  }
                  fabricationProjectsState={fabricationProjectsState}
                  detailingProjectState={detailingProjectState}
                  setDetailingProjectState={setDetailingProjectState}
                  contractNumber={
                    constructionIdentificationState.contractNumber
                  }
                  location={constructionIdentificationState.location}
                  goToFabricationRoute={goToFabricationRoute}
                  onInitFabricationRoute={onInitFabricationRoute}
                />
              )}
          </>
        )}
      />

      <Route
        path={`${path}${EFabricationRoutes.EXTRA_ITENS}`}
        render={() => (
          <ExtraItens
            selectedContractNumber={
              constructionIdentificationState.contractNumber || ''
            }
            contractsState={contractsState}
            extraItensState={extraItensState}
            setExtraItensState={setExtraItensState}
            goToFabricationRoute={goToFabricationRoute}
            onInitFabricationRoute={onInitFabricationRoute}
            hasAnyProjectSelected={
              detailingProjectState.itens.filter(
                (project) => project.projectId !== undefined
              ).length > 0
            }
            comingFromBuyAgain={
              constructionIdentificationState.comingFromBuyAgain
            }
            constructionIdentificationState={constructionIdentificationState}
          />
        )}
      />

      <Route
        path={`${path}${EFabricationRoutes.CHECKOUT}`}
        render={() => (
          <Checkout
            fabricationPurchaseOrder={fabricationPurchaseOrder}
            goToFabricationRoute={goToFabricationRoute}
          />
        )}
      />

      <Route
        path={`${path}${EFabricationRoutes.SUCCESS}`}
        component={FabricationOrderSucess}
      />

      <Route
        path={`${path}${EFabricationRoutes.FABRICATION_REVIEW_ORDER}`}
        render={() => (
          <ReviewOrders
            goToFabricationRoute={goToFabricationRoute}
            onBuyAgain={(fabricationPurchaseState) => {
              setConstructionIdentificationState({
                ...fabricationPurchaseState.constructionIdentification,
                desiredDate: constructionIdentificationState.desiredDate
              });
              setDetailingProjectState(
                fabricationPurchaseState.detailingProject
              );
              setExtraItensState(fabricationPurchaseState.extraItens);
            }}
          />
        )}
      />
    </>
  );
};

export default FabricationRoutes;
